// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Tx8Us","active":"Button_active__3leol","disabled":"Button_disabled__qMMam"};